import $ from '../utils/jquery';

// Load slick as a script that attaches to global jQuery (avoids CommonJS bundling issues)
const loadSlick = () => {
	return new Promise((resolve) => {
		// Check if slick is already loaded
		if ($.fn.slick) {
			resolve();
			return;
		}
		// Load slick dynamically
		const script = document.createElement('script');
		script.src = '/wp-content/themes/sao-2026/assets/scripts/slick.min.js';
		script.onload = resolve;
		document.head.appendChild(script);
	});
};

const $carousel = $( '#issues-quote-carousel' );

const nextArrow = `<button class="slick-arrow slick-next">
	<span class="sr-only">Next</span>
	<i class="fas fa-chevron-right"></i>
</button>`;

const prevArrow = `<button class="slick-arrow slick-prev">
	<span class="sr-only">Previous</span>
	<i class="fas fa-chevron-left"></i>
</button>`;

let options = {
	slidesToShow: 1,
	slidesToScroll: 1,
	adaptiveHeight: true,
	prevArrow,
	nextArrow
}

const bind = () => {
	if ( $carousel.hasClass( 'show-multiple' ) ) {
		options.slidesToShow = 3;
		options.responsive = [
			{
				breakpoint: 1078,
				settings: {
					slidesToShow: 2,
				}
			},
			{
				breakpoint: 720,
				settings: {
					slidesToShow: 1,
				}
			}
		];
	}

	$carousel.find( '.carousel-wrapper' ).slick( options );
};

export default async () => {
	if ( ! $carousel.length ) {
		return;
	}

	await loadSlick();

	bind();
};
